import { OpenInNew } from '@mui/icons-material'
import type { BoxProps } from '@mui/material'
import { Box, Link, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'

import CustomTypography from '@/components/dataDisplay/CustomTypography'
import type { ControllerDescription } from '@/features/controller/types'
import { getElectricianViewUrl } from '@/features/controller/utils/electricianViewLinks'
import type { Site } from '@/features/site/types/site'

export interface ControllerElectricianUILinksProps {
  controller: ControllerDescription
  site: Site
}

export function ControllerElectricianUILinks({
  controller,
  site,
  ...boxProps
}: Readonly<ControllerElectricianUILinksProps & BoxProps>) {
  const { t } = useTranslation()

  if (!site.location) {
    return <Box {...boxProps}>{t('controllers.electrician_ui.missing_location')}</Box>
  }
  // Note: if the controller is lacking an equipment number, all controllers from the resource owner will show
  const electricianViewUrl = getElectricianViewUrl(site, controller)

  return (
    <Box {...boxProps}>
      <CustomTypography color="grey.500" variant="caption">
        {t('controllers.electrician_ui.title')}
      </CustomTypography>
      <Stack alignItems="center" direction="row" spacing={1}>
        <OpenInNew />
        <Link
          href={electricianViewUrl}
          sx={{ textDecoration: 'underline', background: 'none', border: 'none' }}
          target="_blank"
        >
          {t('controllers.electrician_ui.link_to_electrician_view')}
        </Link>
      </Stack>
    </Box>
  )
}
